import React, { useState } from "react";
import Select, { components } from "react-select";
import { FaChevronDown } from "react-icons/fa";
import "./CustomSelect.css";

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <FaChevronDown className="custom-select-arrow" />
        </components.DropdownIndicator>
    );
};

const IndicatorSeparator = () => null;

const CustomSelect = ({
    name,
    label,
    value,
    options = [],
    onChange,
    error,
    placeholder = "",
    required = false,
    isSearchable = false,
    isDisabled = false,
    isClearable = false,
    menuPlacement = "auto",
    className = ""
}) => {

    const [isFocused, setIsFocused] = useState(false);

    const selectedOption =
        options.find(option => option.value === value) || null;

    const handleSelectChange = (selected) => {

        onChange({
            target: {
                name,
                value: selected ? selected.value : "",
                type: "select-one"
            }
        });

    };

    return (

       <div
            id={name}
            className={`custom-select-wrapper ${
                value || isFocused ? "filled" : ""
            } ${error ? "custom-select-error" : ""} ${className}`}
        >

            <Select

                value={selectedOption}

                options={options}

                onChange={handleSelectChange}

                onFocus={() => setIsFocused(true)}

                onBlur={() => setIsFocused(false)}

                placeholder={placeholder}

                isSearchable={isSearchable}

                isDisabled={isDisabled}

                isClearable={isClearable}

                menuPlacement={menuPlacement}

                menuPosition="absolute"

                menuShouldScrollIntoView

                classNamePrefix="horyzen"

                components={{
                    DropdownIndicator,
                    IndicatorSeparator
                }}

                noOptionsMessage={() => "No options found"}

               
            />

            <label
                className={`custom-select-label ${
                    error ? "custom-select-label-error" : ""
                }`}
            >

                {label}

                {required && <span className="required-star">*</span>}

            </label>

           <span
            className={`custom-focus-line ${
                error ? "custom-focus-line-error" : ""
            }`}
        />

        {error && (
            <p className="error-message">
                {error}
            </p>
        )}

        </div>

    );

};

export default CustomSelect;